
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import { init, ECharts, EChartsOption } from 'echarts'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Charts, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      columns: [],
      data: [],
      spinning: true
    })
    const color = globalsets.getColor()
    pageData.columns = [
      {
        title: '配股公告日',
        dataIndex: 'time',
        key: 'time'
        // width: "100px"
      },
      {
        title: '配股价格(元)',
        dataIndex: 'PlaPrice',
        key: 'PlaPrice',
        slots: { customRender: 'decimal' }
      },
      {
        title: '实际配股数量(股)',
        dataIndex: 'ActualPlaVol',
        key: 'ActualPlaVol',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '实际募集总额(元)',
        dataIndex: 'PlaProceeds',
        key: 'PlaProceeds',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '股权登记日',
        dataIndex: 'gqdjr',
        key: 'gqdjr'
      },
      {
        title: '除权基准日',
        dataIndex: 'cqjzr',
        key: 'cqjzr'
      },
      {
        title: '配股方案',
        dataIndex: 'AdjustedPlaRatioPl',
        key: 'AdjustedPlaRatioPl',
        ellipsis: true
      }
    ]
    watch(
      () => (props.pageSourceData || {}).AllotmentDetail,
      () => {
        const data = (props.pageSourceData || {}).AllotmentDetail
        pageData.data = handlerData(data)
      },
      { deep: true }
    )
    function handlerData(arr: any) {
      nextTick(() => {
        pageData.spinning = false
      })
      if ((arr || []).length < 1) return []
      arr.sort((a: any, b: any) => {
        return b.PlaProspectusPublDate - a.PlaProspectusPublDate
      })
      arr.forEach((item: any, i: number) => {
        item.index = 'Pgmx' + i
        item.time = item.PlaProspectusPublDate ? window.moment(item.PlaProspectusPublDate * 1000).format('YYYY-MM-DD') : '—'
        item.gqdjr = item.RightRegDate ? window.moment(item.RightRegDate * 1000).format('YYYY-MM-DD') : '—'
        item.cqjzr = item.RightRegDate ? window.moment(item.ExRightDate * 1000).format('YYYY-MM-DD') : '—'
      })
      return arr
    }
    return {
      ...toRefs(pageData)
    }
  }
})
